import { apiClient } from '@/shared/lib/apiClient';
import { paymentApi } from '@/features/booking/api/payment.api';
import type {
  ApiResponse,
  GuideTripExtension,
  TripExtension,
  TripExtensionCheckoutResponse,
  TripExtensionOptions,
} from '@/types';

export const tripExtensionApi = {
  async getOptions(bookingId: string) {
    const response = await apiClient.get<ApiResponse<TripExtensionOptions>>(
      `/bookings/${bookingId}/extension-options`
    );
    return response.data.data!;
  },

  async listForBooking(bookingId: string) {
    const response = await apiClient.get<ApiResponse<TripExtension[]>>(
      `/bookings/${bookingId}/extensions`
    );
    return response.data.data!;
  },

  async create(bookingId: string, hours: number) {
    const response = await apiClient.post<ApiResponse<TripExtension>>(
      `/bookings/${bookingId}/extensions`,
      { hours }
    );
    return response.data.data!;
  },

  async getById(id: string) {
    const response = await apiClient.get<ApiResponse<TripExtension>>(`/extensions/${id}`);
    return response.data.data!;
  },

  async listGuidePending() {
    const response = await apiClient.get<ApiResponse<GuideTripExtension[]>>(
      '/extensions/guide/pending'
    );
    return response.data.data!;
  },

  async accept(id: string) {
    const response = await apiClient.patch<ApiResponse<TripExtension>>(`/extensions/${id}/accept`);
    return response.data.data!;
  },

  async approve(id: string) {
    const response = await apiClient.patch<ApiResponse<TripExtension>>(`/extensions/${id}/approve`);
    return response.data.data!;
  },

  async decline(id: string, reason?: string) {
    const response = await apiClient.patch<ApiResponse<TripExtension>>(
      `/extensions/${id}/decline`,
      { reason }
    );
    return response.data.data!;
  },

  async cancel(id: string, reason?: string) {
    const response = await apiClient.patch<ApiResponse<TripExtension>>(
      `/extensions/${id}/cancel`,
      { reason }
    );
    return response.data.data!;
  },

  async checkout(id: string, returnUrl: string) {
    const response = await apiClient.post<ApiResponse<TripExtensionCheckoutResponse>>(
      `/extensions/${id}/checkout`,
      { returnUrl }
    );
    const data = response.data.data!;
    // Lets the shared payment return page verify this payment after a redirect.
    paymentApi.rememberPayment(data.payment.id);
    return data;
  },
};

export const tripExtensionKeys = {
  all: ['trip-extensions'] as const,
  options: (bookingId: string) => [...tripExtensionKeys.all, 'options', bookingId] as const,
  forBooking: (bookingId: string) => [...tripExtensionKeys.all, 'booking', bookingId] as const,
  guidePending: () => [...tripExtensionKeys.all, 'guide-pending'] as const,
};
